
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import UpdateIcon from '@mui/icons-material/Update';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';    
import CelebrationIcon from '@mui/icons-material/Celebration';
import TtkList from './TtkList';
const HelecopterBookingTTK = ({ data }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Starting Price :</b>&nbsp;<span>&#8377; {data?.PiecePrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><AirlineSeatReclineNormalIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Seat Available in Helecopter:</b>&nbsp;<span>{data?.seatAvailable}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area Of Working :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-6'>
                            <p> <LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>All Event Services :</b>&nbsp;<TtkList data={data?.eventService} /></p>
                        </div>
                        <div className='col-md-6'>
                            <p> <UpdateIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Helecopter Name & Modal :</b>&nbsp;<TtkList data={data?.helecopterName} /></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HelecopterBookingTTK